import { FunctionComponent } from "react";
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';


interface LisBadgeProps<T = any> {
  element?: T
}

const LisBadge: FunctionComponent<LisBadgeProps> = ({ element }) => {
  const nav = useNavigate()
  return (<>
      <Button onClick={() => nav('lista/'+element?.celula)}>Lista</Button>
  </> );
}

export default LisBadge;
